import { Component, input } from '@angular/core';

@Component({
  selector: 'app-divider',
  imports: [],
  templateUrl: './divider.component.html',
  // Keeps a caller's static `id` attribute off the host element, which would
  // otherwise duplicate the `id` the template below puts on the heading.
  host: { '[attr.id]': 'null' },
})
export class DividerComponent {
  readonly id = input('');
  readonly label = input('');
}
